import { memo, useState, useEffect } from "react";
import HelpUs from "@/components/HelpUs";
import ChatIcon from "@/icons/ChatIcon";
import Link from "next/link";
import ZipCodeSheet from "../ZipCodeSheet/ZipCodeSheet";
import LiveChat from "@/components/LiveChat/LiveChat";

const debounce = (func, wait) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
};

const TopLinks = ({ callBack }) => {
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 100);
    return () => clearTimeout(timer);
  }, []);

  const handleClick = debounce((e) => {
    if (isLoading) {
      e.preventDefault();
      return;
    }
    if (callBack) {
      callBack();
    }
  }, 300);

  const links = [
    { href: "/trade", label: "Builders & Trade" },
    { href: "/rebates", label: "Rebates" },
    { href: "/financing", label: "Financing" },
    { href: "/brands", label: "Brands" },
    { href: "/delivery-and-installation", label: "Delivery & Installation" },
    // { href: "/track-your-order", label: "Track Order" },
    // { href: "/stores", label: "Find Store" },
  ];

  return (
    <>
      <div className="flex items-center lg:px-[0] lg:bg-[#F1F1F1] ">
        <nav className="flex items-center lg:flex-col lg:items-start w-full">
            <ZipCodeSheet className="lg:text-[12px] lg:px-[15px]" />
          {links?.map((link) => (
            <Link
              key={link.href}
              href={link.href}
              onClick={handleClick}
              className={`${
                isLoading ? "pointer-events-none opacity-50" : ""
              } hover:text-gray-300 lg:text-[12px] px-p18 mlg:px-[10px] lg:px-[15px] lg:py-3 lg:border-b lg:border-[#B2B2B3] lg:w-full`}
            >
              {link.label}
            </Link>
          ))}
        </nav>
      </div>
      <div className="flex items-center lg:flex-col lg:items-start lg:px-[0] lg:bg-[#F1F1F1]  ">
        <Link
          href="/track-your-order"
          className={`${
            isLoading ? "pointer-events-none opacity-50" : ""
          } hover:text-gray-300 pr-p18 mlg:pr-[10px] lg:py-3 lg:border-b lg:border-[#B2B2B3] lg:w-full lg:text-[12px] lg:px-[15px]`}
          onClick={handleClick}
        >
          Track Order
        </Link>
        <div
          className={`cursor-pointer hover:text-gray-300 px-p18 mlg:px-[10px] lg:py-3 lg:border-b lg:border-[#B2B2B3] lg:w-full lg:text-[12px] lg:px-[15px] ${
            isLoading ? "pointer-events-none opacity-50" : ""
          }`}
          onClick={handleClick}
        >
          <div className="flex items-center gap-2">
            <ChatIcon className="lg:hidden" />
              <LiveChat />
          </div>
        </div>
        <div
          className={`hover:text-gray-300 px-p18 mlg:px-[10px] lg:border-b lg:border-[#B2B2B3] lg:w-full lg:text-[12px] lg:px-[15px] ${
            isLoading ? "pointer-events-none opacity-50" : ""
          }`}
        >
            <HelpUs title="Help" />
        </div>
        <Link
          href="/stores"
          className={`${
            isLoading ? "pointer-events-none opacity-50" : ""
          } hover:text-gray-300 pl-p18 mlg:pl-[10px] lg:py-3 lg:border-b lg:border-[#B2B2B3] lg:w-full lg:text-[12px] lg:px-[15px]`}
          onClick={handleClick}
        >
          Find Store
        </Link>
      </div>
      {/* <div className=" hidden lg:block">
        <ZipCodeSheet />
      </div> */}
    </>
  );
};

export default memo(TopLinks);
